import React from 'react';
import {useOutlet} from 'reconnect.js';
import withPageEntry from '../../withPageEntry';
import Type1 from './type1';
import Type2 from './type2';
import Type3 from './type3';
import Custom from './custom';
import * as Ant from 'antd';

function Landing(props) {
  const [user, setUser] = useOutlet('user');
  return (
    <div className="list-layout">
      {user ? <h1>Hi, {user.ext?.username}</h1> : <h1>請先登入</h1>}

      <div style={{marginTop: 20}}>
        <Ant.Button
          onClick={() => {
            window.open('https://gds-api.esim4pro.com/org/docs', '_blank');
          }}>
          API 串接文件
        </Ant.Button>
      </div>
    </div>
  );
}

export default withPageEntry(Landing);
